// extracted by mini-css-extract-plugin
export default {"Header":"AppLoadingPage__Header__1Ueug","LogoWrapper":"AppLoadingPage__LogoWrapper__eK8s8","Sidebar":"AppLoadingPage__Sidebar__2E3J1","Content":"AppLoadingPage__Content__1NTW6"};